import { DataProvider } from 'react-admin'
import { SystemLogDto } from '../../dto/system-notifications/system-log.dto'

const fakeLogs: SystemLogDto[] = []

const provider = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getList: (resource, params) =>
    Promise.resolve({ data: fakeLogs, total: fakeLogs.length }),
} as DataProvider

export default provider
